import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import profileReducer from './profileSlice';
import dialogsReducer from './dialogsSlice';
import usersReducer from './usersSlice'; // <-- Добавили

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    dialogs: dialogsReducer,
    users: usersReducer, // <-- Добавили
  },
});